import { connect } from 'react-redux';
import { getCurrentUser } from '../publicSession/selectors';
var mapStateToProps = function (state) { return ({
    currentUser: getCurrentUser(state),
}); };
export default connect(mapStateToProps);
//# sourceMappingURL=CommentModal.container.js.map